import styled from '@emotion/styled';
import { MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const Container = styled.div`
  margin: 0 auto;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding: 0 ${SPACING.MD};
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    padding: 0;
  }
`;
